import{__require as r}from"./global-this.js";import{__require as e}from"./is-callable.js";var i,t;function a(){if(t)return i;t=1;var a=r(),o=e();return i=function(r,e){return arguments.length<2?(i=a[r],o(i)?i:void 0):a[r]&&a[r][e];var i},i}export{a as __require};
//# sourceMappingURL=get-built-in.js.map
